/* eslint-disable max-len */
/* eslint-disable react/no-danger */
import { Grid } from '@mui/material';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import TableOne from './Components/TableOne';
import TableThree from './Components/TableThree';
import TableTwo from './Components/TableTwo';
import { CombineReportEnum, PDFReportEnum, ReportPart1 } from '../../helper';
import { RootState } from '../../../../redux/rootState';
import { JobDetails } from '../../types';

function ComponentJobOrder({ isMorning, dataItem, comments }: { isMorning?: boolean, dataItem?: JobDetails, comments?: string }) {
  const { tableContent, reportPdfResponse1 } = useSelector((state:RootState) => state.reportPdfSliceReducer);

  const data = useMemo(() => (isMorning ? dataItem : reportPdfResponse1?.Ticklers_Data), [isMorning, dataItem, reportPdfResponse1?.Ticklers_Data]);

  return (
    <>
      <table className="w100">
        <tr>
          <td className="textLeft pt10 pb10" style={{ padding: '5px' }}>
            {!isMorning && ReportPart1(tableContent, CombineReportEnum.COMBINE_Job_Order, PDFReportEnum.PDF_Job_Order, 'Job Order')}
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="textCenter underlineHeadingText24">
            {isMorning ? `Job Order: ${data?.JobOrder || ''}` : 'Job Order'}
          </td>
        </tr>
      </table>
      <Grid container spacing={2}>
        <Grid item md={6} sm={12}>
          <TableThree data={data} />
        </Grid>
        <Grid item md={6} sm={12}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: '30px',
            justifyContent: 'center',
          }}
          >
            <TableOne data={data} />
            {data?.VesselInfo && data?.VesselInfo?.length > 0 && <TableTwo data={data} />}
          </div>
        </Grid>
        <Grid item md={6} sm={12}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            fontWeight: 600,
            fontSize: '14px',
            marginTop: '20px',
          }}
          >
            Initial here when completed: ____________
          </div>
        </Grid>
      </Grid>
      {(!isMorning || (data?.EmailInstructions && data?.EmailInstructions?.replace(/<[^>]*>|&nbsp;/g, '')?.trim()?.length > 0)) && <div className="page-break" />}
      {(!isMorning || (data?.EmailInstructions && data?.EmailInstructions?.replace(/<[^>]*>|&nbsp;/g, '')?.trim()?.length > 0)) && (
      <table className="w100">
        <tr>
          <td className="textLeft pt10 pb10" style={{ padding: '5px' }}>
            {!isMorning && ReportPart1(tableContent, CombineReportEnum.COMBINE_Job_Order, PDFReportEnum.PDF_Job_Order, 'Job Order')}
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="textCenter boldHeadingText">
            {`Job #: ${data?.JobOrder || ''}`}
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="underlineHeadingText boldText pl30">
            Email Instructions:
          </td>
        </tr>
      </table>
      )}
      {(!isMorning || (data?.EmailInstructions && data?.EmailInstructions?.replace(/<[^>]*>|&nbsp;/g, '')?.trim()?.length > 0)) && (
      <div
        className="commonText mt20 customDataHtmlStyle p30 pt0"
        style={{ whiteSpace: 'pre-line' }}
        dangerouslySetInnerHTML={{ __html: data?.EmailInstructions || '' }}
      />
      )}
      {isMorning && comments && comments?.replace(/<[^>]*>|&nbsp;/g, '')?.trim()?.length > 0 && <div className="page-break" />}
      {isMorning && comments && comments?.replace(/<[^>]*>|&nbsp;/g, '')?.trim()?.length > 0 && (
      <table className="w100">
        <tr>
          <td className="textLeft pt10 pb10" style={{ padding: '5px' }}>
            {!isMorning && ReportPart1(tableContent, CombineReportEnum.COMBINE_Job_Order, PDFReportEnum.PDF_Job_Order, 'Job Order')}
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="textCenter boldHeadingText">
            {`Job #: ${data?.JobOrder || ''}`}
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="underlineHeadingText boldText pl30">
            Analyst Comments:
          </td>
        </tr>
      </table>
      )}
      {isMorning && comments && comments?.replace(/<[^>]*>|&nbsp;/g, '')?.trim()?.length > 0 && (
      <div
        className="commonText mt20 customDataHtmlStyle p30 pt0"
        style={{ whiteSpace: 'pre-line' }}
        dangerouslySetInnerHTML={{ __html: comments || '' }}
      />
      )}
    </>
  );
}

export default ComponentJobOrder;
